import Slider from 'components/Slider'
import React from 'react'
import { Blogs } from './PostsSlider.style'
import useDeviceDetect from 'components/DeviceDetect'
import BlogItem from 'components/Widgets/BlogItem'
import blogUrl from 'helpers/blogUrl'

const PostsSlider = props => {
  const { posts } = props
  const { isBrowser, isTablet, isSmallBrowser } = useDeviceDetect()

  if (!Array.isArray(posts)) return null

  return (
    <Blogs>
      <Slider settings={{ slidesToShow: isSmallBrowser? 3 : isBrowser ? 4 : isTablet? 2 : 1, infinite: false }}>
        {posts.map(post => {
          return (
            <BlogItem
              key={post.id}
              item={{
                url: blogUrl(post.slug),
                image: post.image,
                name: post.title,
                description: post.description,
                category: post.category,
                time: post.created_at,
              }}
            />
          )
        })}
      </Slider>
    </Blogs>
  )
}

export default PostsSlider
